/* import __COLOCATED_TEMPLATE__ from './save-controls.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { or } from "@ember/object/computed";
import discourseComputed from "discourse-common/utils/decorators";
import TEMPLATE from "./save-controls.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend(dt7948.p({
  classNames: ["controls", "save-button"],
  buttonDisabled: or("model.isSaving", "saveDisabled"),
  didInsertElement() {
    this._super(...arguments);
    this.set("saved", false);
  },
  savingText(saving) {
    return saving ? "saving" : "save";
  }
}, [["method", "savingText", [discourseComputed("model.isSaving")]]])));